import { render, staticRenderFns } from "./ChallengeInProgress.vue?vue&type=template&id=6aa3216b&scoped=true"
import script from "./ChallengeInProgress.vue?vue&type=script&lang=ts"
export * from "./ChallengeInProgress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa3216b",
  null
  
)

export default component.exports